export enum SessionTargetType {
  SESSION = 'Session',
}
